<template>
    <div class="uv-radio-wrapper mr-3" :style="{ '--radio-color': color }">
        <input type="radio" 
        :id="id" 
        :name="nameGroup"
        :checked="value" 
        @change="handleChange"  
        class="uv-radio"/>
        <label :for="id" class="uv-radio-label">
            <div class="uv-radio-icon">
                <div class="uv-radio-dot"></div>
            </div>
            <span class="uv-radio-text">{{ label }}</span>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        color: {
            type: String,
            default: '#0d6efd'
        },
        value: {
            type: Boolean,
            default: false
        },
        nameGroup: {
            type: String,
            required: true
        }
    },
    methods: {
        handleChange(event) {
            this.$emit('change', event.target.checked);
            this.$emit('input', event.target.checked);
        }
    }
}
</script>

<style scoped>
.mouse-pointer {
    cursor: pointer;
}

.uv-radio-wrapper {
    display: inline-block;
}

.uv-radio {
    display: none;
}

.uv-radio-label {
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
}

.uv-radio-icon {
    position: relative;
    width: 1.25em;
    height: 1.25em;
    border: 2px solid #ccc;
    border-radius: 50%;
    transition: border-color 0.3s ease, background-color 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.uv-radio-dot {
    width: 0.5em;
    height: 0.5em;
    background-color: #fff;
    border-radius: 50%;
    transform: scale(0);
    transition: transform 0.25s cubic-bezier(0.45, 0.05, 0.55, 0.95);
}

.uv-radio-text {
    margin-left: 0.5em;
    transition: color 0.3s ease;
}

.uv-radio:checked + .uv-radio-label .uv-radio-icon {
    border-color: var(--radio-color);
    background-color: var(--radio-color);
}

.uv-radio:checked + .uv-radio-label .uv-radio-dot {
    transform: scale(1);
}

.uv-radio:checked + .uv-radio-label .uv-radio-text {
    color: var(--radio-color);
}
</style>
